<template>
  <v-layout>
    <v-flex>
      <div v-if="this.hasAccess(this.PERMISSION_LEVEL_ADMIN)">

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportFiles">Arhiva Completa Documente</v-btn>
        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportData(false)">Raport Clienti [Excel]</v-btn>
        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportAccountancyFiles">Documente
          Contabilitate</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="printInvoices">Print facturi</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportAccountancyInvoices">Raport Facturi
          [Excel]</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportOpisInvoices">Opis Facturi</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportData(true)">Clienti ATHOS [Excel]</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportISCIRReport">Raportare ISCIR</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportANREReport">Raportare ANRE</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportConsumptionReceipts">Bon Consum</v-btn>

        <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportStocks">Materiale Gestiune</v-btn>

      </div>

      <v-btn color="blue darken-1" dark class="mx-2 my-2" @click="exportAnreFiles"
        v-if="this.hasAccess(this.PERMISSION_LEVEL_TECHNICIAN_ANRE)">
        Arhiva Fise ANRE</v-btn>

      <v-row>
        <v-col cols="12">Perioada selectata: {{ dateRangeText }}</v-col>
        <v-col cols="12">
          <v-date-picker v-model="exportDates" range></v-date-picker>
        </v-col>
      </v-row>
      <v-row> </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import { hasAccess, PERMISSION_LEVEL_ADMIN, PERMISSION_LEVEL_TECHNICIAN_ANRE } from '../../utils/permissions';
import { saveAs } from 'file-saver';

export default {

  name: 'export-files',
  data() {
    return {
      search: '',
      dialog: false,
      exportDates: [this.addDays(-90), this.addDays(1)],
      PERMISSION_LEVEL_ADMIN,
      PERMISSION_LEVEL_TECHNICIAN_ANRE,
    };
  },
  created() { },
  computed: {
    dateRangeText() {
      return this.exportDates.join(' ~ ');
    },
  },
  methods: {
    hasAccess,

    async exportData(isAthos) {
      const response = await this.$store.dispatch('clients/getExcelClient', {
        isAthos,
        start: this.exportDates[0],
        end: this.exportDates[1],
      });

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },
    async exportFiles() {
      const response = await this.$store.dispatch('clients/downloadDocuments', {
        start: this.exportDates[0],
        end: this.exportDates[1],
      });
      saveAs(response.data, 'documente.zip');
    },

    async exportAccountancyFiles() {
      const response = await this.$store.dispatch(
        'documents/downloadAccountancyDocuments',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        "filename='(.*)'",
      )[1];
      saveAs(response.data, fileName);
    },

    async printInvoices() {
      const response = await this.$store.dispatch(
        'documents/printInvoices',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportAccountancyInvoices() {
      const response = await this.$store.dispatch(
        'documents/getExcelInvoices',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportOpisInvoices() {
      const response = await this.$store.dispatch(
        'documents/getExcelOpisInvoices',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportISCIRReport() {
      const response = await this.$store.dispatch(
        'documents/getIscirDocuments',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportANREReport() {
      const response = await this.$store.dispatch(
        'documents/getAnreDocuments',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportConsumptionReceipts() {
      const response = await this.$store.dispatch(
        'documents/getConsumptionReceipts',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    async exportAnreFiles() {
      const response = await this.$store.dispatch('documents/downloadAnreDocuments', {
        start: this.exportDates[0],
        end: this.exportDates[1],
      });
      saveAs(response.data, 'documente.zip');
    },

    async exportStocks() {
      const response = await this.$store.dispatch(
        'stocks/exportStocks',
        {
          start: this.exportDates[0],
          end: this.exportDates[1],
        },
      );

      const fileName = response.headers['content-disposition'].match(
        'filename=(.*)',
      )[1];
      saveAs(response.data, fileName);
    },

    addDays(days) {
      const result = new Date();
      result.setDate(result.getDate() + days);
      return result.toISOString().substr(0, 10);
    },
  },
};
</script>
